<template>
  <div class="workbench">
    <div style="display: flex; flex-direction: row; gap: 10px">
      <!-- <WelcomeCard
        style="width: calc(50% - 5px)"
        :images="images"
        :dept-name="$t('workbench.factoryDirector')"
        :description="$t('workbench.directorAssistantDesc')"
      /> -->
      <AlertCard style="width: calc(50% - 5px)" />
    </div>
    <div class="grid-container grid-1 gap-10">
      <!-- <QuickActionCard @action-click="handleActionClick" /> -->
    </div>
    <div class="grid-container grid-1 gap-10">
      <CoreData />
    </div>
    <div class="grid-container grid-1 gap-10">
      <DataTwins />
    </div>
  </div>
</template>

<script>
// import WelcomeCard from '../components/WelcomeCard.vue'
import AlertCard from '../components/Message.vue'
// import QuickActionCard from '../components/QuickActionCard.vue'
import DataTwins from '../components/DataTwins.vue'
import CoreData from '../components/CoreData.vue'

export default {
  name: 'DirectorWorkbench',
  components: {
    // WelcomeCard,
    AlertCard,
    // QuickActionCard,
    DataTwins,
    CoreData
  },
  data() {
    return {
      images: require('@/assets/imgs/workbench/gongzhang.png')
    }
  },
  methods: {
    handleActionClick(item) {
      console.log('点击快捷操作:', item)
      this.$message.success(`打开${item.name}`)
    }
  }
}
</script>

<style lang="scss" scoped>
.grid-container {
  width: 100%;
}
.workbench {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.grid-1 {
  display: grid;
  grid-template-columns: 1fr;
}
.grid-2 {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
}
.grid-3 {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
}
.gap-10 {
  gap: 10px;
}
</style>
